import React, {useContext} from "react";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) return;
    var win = window.open(url, "_blank");
    win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <h1
          className={isDark ? "dark-mode skills-heading" : "skills-heading"}
        >
          {bigProjects.title}
        </h1>
        {bigProjects.subtitle && (
          <p
            className={
              isDark
                ? "dark-mode project-subtitle subTitle"
                : "project-subtitle subTitle"
            }
          >
            {bigProjects.subtitle}
          </p>
        )}
        <div className="projects-container">
          {bigProjects.projects.map((project, i) => {
            return (
              <div
                key={i}
                className={
                  isDark
                    ? "dark-mode project-card project-card-dark"
                    : "project-card project-card-light"
                }
              >
                <div className="project-detail">
                  <h5
                    className={
                      isDark ? "dark-mode card-title" : "card-title"
                    }
                  >
                    {project.projectName}
                  </h5>
                  <p
                    className={
                      isDark ? "dark-mode card-subtitle" : "card-subtitle"
                    }
                  >
                    {project.projectDesc}
                  </p>
                  {project.stack && project.stack.length > 0 && (
                    <div className="project-stack-pills">
                      {project.stack.map((tag, j) => (
                        <span
                          key={j}
                          className={
                            isDark
                              ? "dark-mode stack-pill"
                              : "stack-pill"
                          }
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                  {project.footerLink && project.footerLink.length > 0 && (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, j) => {
                        return (
                          <span
                            key={j}
                            className={
                              isDark
                                ? "dark-mode project-tag"
                                : "project-tag"
                            }
                            onClick={() => openUrlInNewTab(link.url)}
                          >
                            {link.name}
                          </span>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Fade>
  );
}
